<template>
  <span>
    <router-link :to="'/purchasing/purchaseorders/' + id" v-if="userHasReadPermission(PermissionTypes.PurchasingPermissionTypes.purchaseOrder)" :target="target" :class="{'router-link-newtab': newTab}">
      {{name}}
    </router-link>
    <span v-else>
      {{name}}
    </span>
  </span>
</template>

<script>
export default {
  name: 'LinkPurchaseOrder',
  props: {
    id: Number,
    name: String,
    newTab: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    target() {
      if(this.newTab)
        return '_blank'

      return '_self'
    }
  }
}
</script>
